import { Box } from '@mui/material';
import { APPOINTMENTS_GRID_COLUMNS } from './tabTableLayout';
import { ProfileAppointment } from './helpers/appointmentRowContent';
import AppointmentTableRow from './AppointmentTableRow';

interface Props {
  appointments: ProfileAppointment[];
  timezone: string;
  now: Date;
  onSelectAppointment: (appointment: ProfileAppointment) => void;
}

function AppointmentsTable({
  appointments,
  timezone,
  now,
  onSelectAppointment,
}: Props) {
  return (
    <Box>
      <Box
        sx={{
          display: { xs: 'none', sm: 'grid' },
          gridTemplateColumns: APPOINTMENTS_GRID_COLUMNS,
          columnGap: '24px',
          paddingBottom: '12px',
          borderBottom: '1px solid',
          borderBottomColor: 'common.black',
          color: 'text.secondary',
          typography: 'body2',
        }}>
        <Box>Date</Box>
        <Box>Service</Box>
        <Box>Artist</Box>
        <Box sx={{ textAlign: 'right' }}>Value</Box>
        <Box />
      </Box>
      {appointments.map(appointment => (
        <AppointmentTableRow
          key={appointment.appointmentId}
          appointment={appointment}
          timezone={timezone}
          now={now}
          onSelect={onSelectAppointment}
        />
      ))}
    </Box>
  );
}

export default AppointmentsTable;
